import { Outlet } from "react-router-dom";
import Navbar from "../../ui/navbar";
import styles from "./layout.module.css";

const Layout = () => {
    return (
        <div className={styles.layout}>
          <Navbar />
          <main className={styles.content}>
            <Outlet />
          </main>
        </div>
      );
};

export default Layout;